import { ArrowDown, ArrowUp, AlertTriangle, Trash2 } from "lucide-react";

const statusMap = {
  IN: {
    class: "bg-green-100 text-green-700",
    icon: ArrowDown,
  },
  OUT: {
    class: "bg-red-100 text-red-700",
    icon: ArrowUp,
  },
  NG: {
    class: "bg-yellow-100 text-yellow-700",
    icon: AlertTriangle,
  },
  WASTAGE: {
    class: "bg-gray-200 text-gray-700",
    icon: Trash2,
  },
};

export default function StatusBadge({ status }) {
  const config = statusMap[status] || {};
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${config.class}`}
    >
      {Icon && <Icon size={12} />}
      {status}
    </span>
  );
}